module.exports = __webpack_public_path__ + "static/08-3f40c943054cc0aa7c0ba5389c6d7c3b.png";